import { useMemo } from 'react';
import { useGetProcessorJobStageTasksQuery } from '../api';
/**
 * Hook to get all processor job stage tasks for a specific processor job stage id.
 *
 * @param params the request parameters to fetch the processor job stage tasks.
 *
 * @returns an object with a list of processor job stage tasks, loading state, fetching state, error state and error object.
 */
export const useProcessorJobStageTasks = (params) => {
    const { data: tasksResponse, isLoading, isFetching, isError, error, } = useGetProcessorJobStageTasksQuery(params);
    return useMemo(() => {
        const paginatedCount = tasksResponse?.count || 0;
        const tasks = tasksResponse?.results || [];
        const next = tasksResponse?.next;
        const previous = tasksResponse?.previous;
        return {
            tasks,
            paginatedCount,
            next,
            previous,
            isLoading,
            isFetching,
            isError,
            error,
        };
    }, [tasksResponse, isLoading, isFetching, isError, error]);
};
